module.exports = __webpack_public_path__ + "static/img/wanted4.ca8f37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted4.png
// module id = QGoN
// module chunks = 1 3